import React, {PropsWithChildren, useCallback, useState} from 'react';
import {M3uMedia} from "../../lib/m3u";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Streaming from "../../components/Streaming";
import {playlistShortlistService} from "../../services/playlist/PlaylistShortlistService";
import styles from "./Shortlist.module.css";
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {WordFilter} from "../../components/WordFilter";
import ChannelsListFromService from "../../components/ChannelsList/ChannelsListFromService";
import {AddToShortlist} from "../../components/ManualAddToShortlist";
import Collapsable from "../../components/common/Collapsable";

interface Props extends PropsWithChildren<any> {

}

function Shortlist(props: Props) {

    const [rerenderTrigger, setRerenderTrigger] = useState(0);
    const [filterWords, setFilterWords] = useState<string[]>([]);

    const removeFromShortlist = useCallback((channel: M3uMedia) => {
        playlistShortlistService.remove(channel).then(() => {
            // Force a re-render of the Shortlist component
            setRerenderTrigger(prev => prev + 1);
        });
    }, []);

    const refreshShortlist = (channel: M3uMedia) => {
        // Force a re-render of the Shortlist component
        setRerenderTrigger(prev => prev + 1);
    };

    const ChannelActions = ({data}: { data: M3uMedia }) => (
        <div className={styles.channelActions}>
            <div className={styles.tooltipContainer} title="Fjern fra shortlist">
                <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => removeFromShortlist(data)}
                    className={styles.removeIcon}
                />
            </div>
        </div>
    );

    const handleFilterSubmit = (words: string[]) => {
        setFilterWords(words);
    };

    return (
        <div className={styles.boxcontainer}>
            <div className={`${styles.box} ${styles.leftBox}`}>
                <div className={styles.inputContainer}>
                    <AddToShortlist useCollapsable={true} onAdded={refreshShortlist}/>
                    <Collapsable defaultExpanded={false} maximizedText={' - Filter'} minimizedText={'+ Filter'}>
                        <WordFilter onSubmit={handleFilterSubmit}/>
                    </Collapsable>
                </div>
                <div className={styles.channelsListContainer}>
                    <ChannelsListFromService
                        RowActionsComponent={ChannelActions}
                        playlistService={playlistShortlistService}
                        key={rerenderTrigger}
                        wordsFilter={filterWords}
                    />
                </div>
            </div>
            <div className={`${styles.box} ${styles.rightBox}`}>
                <Streaming/>
            </div>
        </div>
    );
}

export default Shortlist;